import React, { useState } from "react";
import axios from "axios";
import { backend } from "../../../../backend";
import { logAxiosError } from "../../../../logging/error";
import ConfirmationModal from "../../../../components/ConfirmationModal/ConfirmationModal";
import "./emailForm.css";
import { useForm } from "react-hook-form";
import RoundedButton from "../../../../components/Buttons/RoundedButton/RoundedButton";

function EmailForm({ serverError, setServerError }) {
  const [showEmailModal, setShowEmailModal] = useState("");
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const onSubmit = async (formData) => {
    try {
      await handleFormSubmit(formData);
      showEmailModal(true);
    } catch (error) {
      console.error(error);
    }
  };

  const handleFormSubmit = async (formData) => {
    setServerError("");
    try {
      const { data } = await axios.post(
        backend("/api/users/forgot/password"),
        formData,
      );
      if (data.status) {
        setShowEmailModal(true);
      }
    } catch (error) {
      logAxiosError(error);
      setServerError(error.response?.data?.msg);
    }
  };

  return (
    <>
      <div className="forgot-password-outer"></div>
      <div className="forgot-password-component">
        <h1>Glömt lösenord?</h1>
        <form onSubmit={handleSubmit(onSubmit)}>
          <label htmlFor="forgot-password-email">
            Ange din e-postadress nedan för att återställa ditt lösenord
          </label>
          <input
            data-testid="forgot-pw-input"
            type="email"
            {...register("email", { required: true })}
          />
          {serverError ? (
            <p
              data-testid="forgot-pw-server-error"
              id="forgot-password-server-error-msg"
            >
              {serverError}
            </p>
          ) : (
            errors.email && (
              <span data-testid="forgot-pw-empty-error">
                Vänligen ange en giltig e-postadress
              </span>
            )
          )}
          <div>
            {/* <button data-testid="forgot-pw-continue-btn">Fortsätt</button> */}
            <RoundedButton
              dataTestID="forgot-pw-continue-btn"
              label="Fortsätt"
              color="green"
              size="md"
            />
          </div>
        </form>
        <p>
          Läs om hur vi hanterar personlig information i våra{" "}
          <a
            id="forgot-pw-terms"
            href="/anvandarvillkor"
            target="_blank"
            rel="noopener noreferrer"
          >
            Användarvillkor
          </a>
          .
        </p>
      </div>
      {showEmailModal && (
        <ConfirmationModal
          heading="Återställ ditt lösenord"
          text="Om e-postadressen är registrerad hos oss har ett mejl med instruktioner skickats. Klicka på länken i mejlet för att återställa ditt lösenord."
          setShowModal={() => setShowEmailModal(false)}
        />
      )}
    </>
  );
}

export default EmailForm;
